import { PIG_LOCKED_QUESTION_MNS } from './constants';

// WI 95280. `pig` is PigButtonStateDto from FullApplicationFormDto, added by WI 94100. Its
// `alreadyApplied` flag mirrors Application.IsPigApplied.
//
// The lock deliberately tests only that one flag: IsPigApplied can only ever be set for a
// gATEway-PLUTUS-Lawsys policy that was Lost/Abandoned with a contingent premium, so the story's other
// preconditions are already implied - and the lock must not lift if the status later changes.
export const isPigApplied = (selectedApplication) =>
    !!selectedApplication?.pig?.alreadyApplied;

export const isPigLockedQuestion = (machineName, selectedApplication) =>
    !!machineName
    && isPigApplied(selectedApplication)
    && PIG_LOCKED_QUESTION_MNS.includes(machineName);

// AC1 asks for the edit icons to be hidden; the agreed presentation replaces each hidden pencil with a
// tooltip explaining why. That replacement is only correct on a row that HAD a pencil.
// Not every locked question does: in the UK seed the four Damages questions have no editing setting of their
// own (they are reachable only through the LikelyClaimsTrack pencil), so they never showed an icon and must
// not gain one. `editingSetting` is the question's editing/approval setting, which is seed data and so is
// unaffected by the lock itself.
export const shouldShowPigLockTooltip = (machineName, selectedApplication, editingSetting) =>
    !!editingSetting && isPigLockedQuestion(machineName, selectedApplication);
